import config from './../config';
import * as treeActions from './ActionTree';
import {bindParams, categoryItemMediator} from "../utils/api";
import * as api from './api';

const CONFIG = config();







export const getTree = () => {
	return (dispatch) => {
		dispatch(api.requestStart());
		return fetch(CONFIG.URL_END_CATEGORIES_ALL).then(result => result.json()).then((result) => {
			dispatch(api.requestEnd());
			dispatch(treeActions.treeUpdateAll(result.response.map(categoryItemMediator)));
		});
	}
};

export const add = (title, parent_id) => {
	return dispatch => {
		dispatch(api.requestStart());
		return fetch(bindParams(CONFIG.URL_END_CATEGORIES_CREATE, {title, parent_id}))
			.then(result => result.json())
			.then(result => {
				let item = categoryItemMediator(result.response);
				dispatch(api.requestEnd());
				dispatch(treeActions.treeAdd(item))
			});
	}
};

export const remove = (id) => {
	return dispatch => {
		return fetch(bindParams(CONFIG.URL_END_CATEGORIES_DELETE, {id}), {method: 'POST'})
			.then(result => result.json())
			.then(result => {
				dispatch(api.requestEnd());
				dispatch(treeActions.treeRemove(id));
			});
	};
};



// WEBPACK FOOTER //
// ./frontend/actions/apiEndCategorisActions.js